import { Input } from "common/InputForm";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { changePasswordApi } from "services/changePassword";
import commonMessages from "utils/commonMessage";
import { regex } from "utils/formValidator";
import { toastMessage } from "utils/toastMessage";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";

const ChangePassword = () => {
  const {
    OLD_PASSWORD,
    NEW_PASSWORD,
    CONFIRM_PASSWORD,
    SAME_PASSWORD,
    VALID_PASSWORD,
    OLD_NEW_SAME_PASSWORD,
  } = commonMessages;


  const { passwordRegex } = regex;
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  // const [buttonLoader, setButtonLoader] = useButtonLoader("Change Password");

  const [changePasswordFields, setChangePasswordFields] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [inputToggle, setInputToggle] = useState({
    newPassword: false,
    confirmPassword: false,
    oldPassword: false,
  });

  const validation = () => {
    let status = true;
    const error = {};
    if (!changePasswordFields.oldPassword) {
      error["oldPassword"] = OLD_PASSWORD;
      status = false;
    }
    //  else if (!changePasswordFields?.oldPassword.match(passwordRegex)) {
    //   error["oldPassword"] = VALID_PASSWORD;
    //   error["oldPasswordErr"] = true;
    //   status = false;
    // }
    if (!changePasswordFields?.newPassword) {
      error["newPassword"] = NEW_PASSWORD;
      status = false;
    } else if (!changePasswordFields?.newPassword.match(passwordRegex)) {
      error["newPassword"] = VALID_PASSWORD;
      error["newPasswordErr"] = true;
      status = false;
    }
    if (!changePasswordFields?.confirmPassword) {
      error["confirmPassword"] = CONFIRM_PASSWORD;
      status = false;
    } else if (!changePasswordFields?.confirmPassword.match(passwordRegex)) {
      error["confirmPassword"] = VALID_PASSWORD;
      error["confirmPasswordErr"] = true;
      status = false;
    }
    if (changePasswordFields.oldPassword && changePasswordFields.newPassword) {
      if (
        changePasswordFields?.oldPassword === changePasswordFields?.newPassword
      ) {
        error["newPassword"] = OLD_NEW_SAME_PASSWORD;
        error["newPasswordErr"] = true;
        status = false;
      }
    }
    if (
      changePasswordFields.confirmPassword &&
      changePasswordFields.newPassword
    ) {
      if (
        changePasswordFields?.confirmPassword !==
        changePasswordFields?.newPassword
      ) {
        error["newPassword"] = SAME_PASSWORD;
        error["newPasswordErr"] = true;
        status = false;
      }
    }
    setErrors(error);
    return status;
  };

  // console.log(errors.confirmPassword,"Error");

  const changePasswordHandler = async (e) => {
    e.preventDefault();
    const status = validation();
    // console.log(status,"Status");
    if (validation()) {
      try {
        // setButtonLoader(true);
        const res = await changePasswordApi(changePasswordFields);
        if (res?.data?.status === 200) {
          toastMessage(res?.data?.message, "success", "changePassword");
          setChangePasswordFields({});
          navigate("/dashboard");
        } else {
          toastMessage(res?.data?.message, "error", "changePassword");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        // setButtonLoader(false);
      }
    }
  };

  //   Toggle Input Type Handler
  const toggleInputTypeHandler = (id) => {
    setInputToggle({ ...inputToggle, [id]: !inputToggle[id] });
  };

  // Handling input field onchange
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setChangePasswordFields({ ...changePasswordFields, [name]: value });
  };
  return (
    <>
      <div className="add_employee_wrap">
        <div className="breadcrumb">
          <ul>
            <li>
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li>Change Password</li>
          </ul>

        </div>

        <div className="add_employee _box">
          <form className="w-50">
            <div className="form_field_wrap">
              <div className="form_field has_icon">
                <Input
                  className={"form-control input"}
                  value={changePasswordFields.oldPassword}
                  onChange={onChangeHandler}
                  label={"Old Password"}
                  placeholder={"Enter old password"}
                  name={"oldPassword"}
                  error={errors?.oldPassword}
                  extraErr={errors?.oldPasswordErr}
                  type={inputToggle.oldPassword ? "text" : "password"}
                />

                <span
                  className="password_icons"
                  onClick={() => toggleInputTypeHandler("oldPassword")}
                >
                  {inputToggle.oldPassword ? (
                    <IoEyeOffOutline />
                  ) : (
                    <IoEyeOutline />
                  )}
                </span>
              </div>
            </div>

            <div className="form_field_wrap">
              <div className="form_field has_icon">
                <Input
                  className={"form-control input"}
                  value={changePasswordFields.newPassword}
                  onChange={onChangeHandler}
                  label={"New Password"}
                  placeholder={"Enter new password"}
                  name={"newPassword"}
                  error={errors?.newPassword}
                  extraErr={errors?.newPasswordErr}
                  type={inputToggle.newPassword ? "text" : "password"}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  onCopy={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                />

                <span
                  className="password_icons"
                  onClick={() => toggleInputTypeHandler("newPassword")}
                >
                  {inputToggle.newPassword ? (
                    <IoEyeOffOutline />
                  ) : (
                    <IoEyeOutline />
                  )}
                </span>
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field has_icon">
                <Input
                  className={"form-control input"}
                  value={changePasswordFields.confirmPassword}
                  onChange={onChangeHandler}
                  onPaste={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  onCopy={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  label={"Confirm Password"}
                  placeholder={"Enter confirm password"}
                  name={"confirmPassword"}
                  error={errors.confirmPassword || ""}
                  extraErr={errors?.confirmPasswordErr}
                  // type={inputToggle.confirmPassword ? "text" : "password"}
                  type={"text"}
                />

                {/* <span
                  className="password_icons"
                  onClick={() => toggleInputTypeHandler("confirmPassword")}
                >
                  {inputToggle.confirmPassword ? (
                    <IoEyeOffOutline />
                  ) : (
                    <IoEyeOutline />
                  )}
                </span> */}
              </div>
            </div>
            <div className="text-center">
              <button
                // ref={buttonLoader}
                className="button"
                onClick={changePasswordHandler}
              >
                Change Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
